/* eslint-disable no-lone-blocks */
/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */

// import { _ } from 'core-js'

// eslint-disable-next-line camelcase, max-len
const s_actionFilePath = 'data:/../apps/NRE/models/skeletonModel/actions'
// eslint-disable-next-line camelcase
const s_actionData = [
  {
    name: 'idle',
    file: 'Idle.fbx', // 待机
  },
  {
    name: 'walk',
    file: 'Walking.fbx', // 行走
  },
  {
    name: 'run',
    file: 'Running.fbx', // 跑
  },
]
// 节点的类型集合
const EnumObjectTypes = [
  'modelFile', // 模型类型
]
const actionList = []
// 生成guid
const generateGUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}
const isJSONObj = (str) => {
  if (typeof str === 'string') {
    try {
      const obj = JSON.parse(str)
      if (typeof obj === 'object' && obj && Object.keys(obj).length) {
        // typeof null 也为 object
        return true
      }
      return false
    } catch (e) {
      return false
    }
  }
  return false
}


// 加载模型
const loadModel = async (file, name, parentNode, player) => {
  const node = await player.Native.Node.loadFile([file])
  await player.Native.Node.setProperty(node, { parent: parentNode, name })
  await player.Native.Node.addToFactory(node)
  return node
}
// 加载人物模型
const loadAnimationClipTemplates = async (actionFilePath, actionData, player) => {
  if (actionList && actionList.length > 0) return actionList

  for (let i = 0; i < actionData.length; i += 1) {
    const file = `${actionFilePath}/${actionData[i].file}`
    const isExist = await player.Native.File.exists(file)
    if (isExist) {
      const action = await player.Native.SkeletonNode.loadSkeletonNodeAnimationData(file)
      player.Native.AnimationClip.setName(action, actionData[i].name)
      actionList.push(action)
    } else {
      // console.log(file, '文件未找到')
    }
  }
  return actionList
}
// 加载人物模型
const loadPersonAnimation = async (file, name, parentNode, player) => {
  const personNode = await player.Native.SkeletonNode.loadSkeletonNode(file)
  await player.Native.NodeProxy.setNodeInfo(personNode, { name })
  await player.Native.NodeProxy.setNodeParent(personNode, parentNode)
  // 将动作附加到人物模型上
  const manBones = await player.Native.SkeletonNode.bones(personNode)
  const manMixer = await player.Native.SkeletonNode.mixer(personNode) /*  */
  // 从动作库中复制人物动作
  const srcClips = await loadAnimationClipTemplates(s_actionFilePath, s_actionData, player)
  // 关联动作片段
  const newClips = await player.Native.AnimationClip.cloneClipsAddAttachTrackDataNames(
    srcClips,
    manBones
  )
  // 添加动作片段到人物模型的动画混合器上
  await player.Native.AnimationClip.addClips(manMixer, newClips)
  // 获取 待机 动作控制器，播放人物待机动作
  const defaultClipAction = await player.Native.AnimationAction.clipAction(manMixer, 'idle')
  await player.Native.AnimationAction.fadeIn(defaultClipAction, 1.0)
  return personNode
}
const loadSceneFromJson = async (obj, parentNode, player) => {
  console.log('loadSceneFromJson', obj, parentNode)
  let node = null
  // 根据节点类型，序列化某些特有类型的节点数据
  switch (obj.code.type) {
    case 'modelFile':
      node = await loadModel(obj.code.filePath, obj.code.id, parentNode, player)
      break
    default:
      // 层级节点，直接根据名称创建节点
      node = await player.Native.Node.create()
      break
  }
  // 节点创建失败，返回nullptr
  if (node === null || node === 0) return
  // 设置节点属性
  await player.Native.Node.setProperty(node, {
    name: obj.name,
    code: JSON.stringify(obj.code),
    parent: parentNode,
    localTrans: obj.localPosition,
    localRot: obj.localRotation,
    localScale: obj.localScaling,
  })
  // 递归子，继续创建
  if (obj.children && obj.children.length) {
    for (let i = 0; i < obj.children.length; ++i) {
      await loadSceneFromJson(obj.children[i], node, player)
    }
  }
}
// 保存场景到json对象
const saveSceneToJson = async (node, player) => {
  if (!node) return null
  const obj = {}
  // 序列化节点的基本信息
  const nodeInfo = await player.Native.NodeProxy.getNodeInfo(node)
  obj.name = nodeInfo.name
  obj.code = nodeInfo.code ? JSON.parse(nodeInfo.code) : ''
  obj.guid = nodeInfo.id
  // 序列化节点的变换信息
  obj.localPosition = await player.Native.NodeProxy.localTranslation(node)
  obj.localRotation = await player.Native.NodeProxy.localRotation(node)
  obj.localScaling = await player.Native.NodeProxy.localScaling(node)
  // 根据节点类型，序列化某些特有类型的节点数据
  if (obj.code.type) {
    const modelChildren = await player.Native.NodeProxy.getNodeChildren(node)
    const modelChild = _.filter(modelChildren, (item) => {
      return item.code && isJSONObj(item.code) && JSON.parse(item.code).type
    })
    if (!_.isEmpty(modelChild)) {
      obj.children = []
      for (let i = 0; i < modelChild.length; i += 1) {
        const childObj = await saveSceneToJson(modelChild[i].nodePtr, player)
        if (childObj) {
          obj.children.push(childObj)
        }
      }
    }
    return obj
  }
  // 层级节点，需要继续递归
  obj.children = []
  const childrenInfos = await player.Native.NodeProxy.getNodeChildren(node)
  const filterChilds = _.filter(childrenInfos, (el) => {
    return el.code
  })
  for (let i = 0; i < filterChilds.length; ++i) {
    const childObj = await saveSceneToJson(filterChilds[i].nodePtr, player)
    if (childObj != null) obj.children.push(childObj)
  }
  return obj
}
// 通过指定节点去查下面的子节点 nodeType 指定节点的类型，obj 需要筛选的对象数据源，arr 接收筛选后的数据集合
const getNodesByNodeType = async (obj, arr = []) => {
  // let currentNodeType = obj.code && obj.code.type
  const currentNodeType = obj?.code?.type
  if (EnumObjectTypes.includes(currentNodeType)) {
    const nowObj = _.cloneDeep(obj)
    delete nowObj.children
    arr.push(nowObj)
  }
  // 递归子，继续创建
  if (obj.children && obj.children.length) {
    for (let i = 0; i < obj.children.length; ++i) {
      await getNodesByNodeType(obj.children[i], arr)
    }
  }
  return arr
}
export {
  saveSceneToJson,
  loadSceneFromJson,
  isJSONObj,
  loadModel,
  loadPersonAnimation,
  getNodesByNodeType,
  generateGUID,
}
